// Lớp gọi API cho service Trình ký V2. Mọi lời gọi mạng gom về đây.
import Axios from "axios";
import { URL_LIST_ALL } from "../../configs/api";
import { EP } from "../constants/trinhKy";

const url = (path) => URL_LIST_ALL + path;

export const trinhKyApi = {
  listTypes: (cfg) => Axios.get(url(EP.type + "?limit=1000"), cfg),

  // Template bước ký theo loại tờ trình (dựng quy trình khi tạo mới).
  stepsTemplate: (cfg, wfType) =>
    Axios.get(
      url(EP.stepTemplate + "?status=1&pagetype=totrinh&orderby=position-asc&wf_type=" + wfType),
      cfg
    ),

  getDetail: (cfg, id) => Axios.get(url(EP.request + "/" + id), cfg),
  create: (cfg, payload) => Axios.post(url(EP.request), payload, cfg),
  update: (cfg, id, payload) => Axios.put(url(EP.request + "/" + id), payload, cfg),
  cancel: (cfg, id) => Axios.put(url(EP.request + "/" + id), { status: 4 }, cfg),

  stepAction: (cfg, stepId, data) => Axios.put(url(EP.step + "/" + stepId), data, cfg),
  addStep: (cfg, payload) => Axios.post(url(EP.step), payload, cfg),
  removeStep: (cfg, stepId) => Axios.put(url(EP.step + "/" + stepId), { status: 0 }, cfg),

  listMessages: (cfg, id) =>
    Axios.get(url(EP.message + "?limit=10000&orderby=id-desc&request_id=" + id), cfg),
  sendMessage: (cfg, payload) => Axios.post(url(EP.message), payload, cfg),

  searchTags: (cfg, id, key) =>
    Axios.get(url(EP.searchTags + "?wf_id=" + id + "&search_key=" + key), cfg),

  // Trang tra cứu công khai theo hash_code.
  getByHash: (cfg, hash) => Axios.get(url("xem-to-trinh-v2/" + hash), cfg),
  regenerateFile: (cfg, hash) => Axios.post(url("ghepfilettr-v2"), { code: hash }, cfg),
};
